export default __webpack_public_path__ + "static/media/rotbehOloom.6b032c98.jpeg";